<template>
    <div>
        <div class="container">
            404
            <br>
            page is not found! :(
        </div>
    </div>
</template>
<script>
    export default {}
</script>
